import React, { createContext, useContext, useState, ReactNode } from "react";

interface DashboardContextType {
  currentDashboard: any | null;
  setCurrentDashboard: (dashboard: any | null) => void;
  refreshDashboard: () => void;
}

const DashboardContext = createContext<DashboardContextType | undefined>(
  undefined
);

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  if (context === undefined) {
    throw new Error("useDashboard must be used within a DashboardProvider");
  }
  return context;
};

interface DashboardProviderProps {
  children: ReactNode;
}

export const DashboardProvider: React.FC<DashboardProviderProps> = ({
  children,
}) => {
  const [currentDashboard, setCurrentDashboard] = useState<any | null>(null);

  const refreshDashboard = () => {
    // This would typically refetch dashboard data
    // For now, we'll just trigger a re-render
    setCurrentDashboard({ ...currentDashboard });
  };

  const value: DashboardContextType = {
    currentDashboard,
    setCurrentDashboard,
    refreshDashboard,
  };

  return (
    <DashboardContext.Provider value={value}>
      {children}
    </DashboardContext.Provider>
  );
};




